<!-- 底部 - 操作面板 -->
<template>
    <div class="pup-mast-transparent pub-menu-popup-righttop" @click.self="closePanel">
        <div class="pub-menu-popup-righttop-wrap" :class="[cacheIsShowCont ? 'slide-in' : 'slide-out']" @click.self="closePanel">
            <slot></slot>
        </div>
    </div>
</template>
<style>
.pub-menu-popup-righttop-wrap{
    width: 100%;
    min-height: 1rem;
    max-height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    transition: all 0.5s ease;
    transform: translateY(-100%);
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}
.pub-menu-popup-righttop-wrap.slide-in{
    animation: slideInToDown 0.5s 1 ease;
    animation-delay: 0s;
    animation-fill-mode: forwards;
}
.pub-menu-popup-righttop-wrap.slide-out{
    animation: slideOutToUp 0.5s 1 ease;
    animation-delay: 0s;
    animation-fill-mode: forwards;
}
.pub-menu-popup-righttop-wrap .pub-menu-popup-list{
    flex: 0 0 auto;
    margin-top: 1.06rem;
    background-color: #ffffff;
    border: 1px solid #b5b5b5;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
}
.pub-menu-popup-righttop-wrap .pub-menu-popup-list .pub-menu-item{
    flex: 0 0 auto;
    padding: 0.16rem 0.2rem;
    text-align: right;
    font-size: 0.28rem;
    color: #333333;
    line-height: 0.5rem;
    border-bottom: 1px solid #b5b5b5;
}
.pub-menu-popup-righttop-wrap .pub-menu-popup-list .pub-menu-item:last-child{
    border: 0;
}
</style>
<script>
export default {
    props: {
        isShowCont: { //是否显示面板内容
            type: Boolean,
            default: false
        },
        contStyleType: { //面板内容风格: 0:透明背景, 1:白色背景
            type: Number,
            default: 1
        },
    },
	data () {
		return {
			cacheIsShowCont: false,
		}
    },
    mounted(){
        this.cacheIsShowCont = this.isShowCont;
    },
    watch: {
        isShowCont(){
            this.cacheIsShowCont = this.isShowCont;
        },
    },
	methods: {
        closePanel() {
            this.cacheIsShowCont = false;
            let delayClosePanel = setTimeout(() => {
                this.$emit("closePanel");
            }, 500);
        },
	}
}
</script>


// WEBPACK FOOTER //
// src/shared/components/control/menu-popup-righttop.vue